import { Link } from 'react-router-dom'
import { MailOutlined, PhoneOutlined, EnvironmentOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'

const Footer = () => {
  const { t } = useTranslation()
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container-custom py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* 公司信息 */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-primary-500 to-primary-700 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">AI</span>
              </div>
              <span className="font-bold text-xl text-white">AI视觉科技</span>
            </div>
            <p className="text-gray-400 text-sm">
              {t('footer.description')}
            </p>
          </div>

          {/* 快速链接 */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="hover:text-primary-400 transition-colors">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/cases" className="hover:text-primary-400 transition-colors">
                  {t('nav.cases')}
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-primary-400 transition-colors">
                  {t('nav.services')}
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-primary-400 transition-colors">
                  {t('nav.about')}
                </Link>
              </li>
            </ul>
          </div>

          {/* 服务范围 */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t('services.title')}</h3>
            <ul className="space-y-2 text-sm">
              <li>{t('features.objectDetection.title')}</li>
              <li>{t('features.imageSegmentation.title')}</li>
              <li>{t('features.ocrRecognition.title')}</li>
              <li>{t('features.defectDetection.title')}</li>
              <li>{t('features.deepLearning.title')}</li>
              <li>{t('features.edgeComputing.title')}</li>
            </ul>
          </div>

          {/* 联系方式 */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t('footer.contactUs')}</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-2">
                <MailOutlined className="mt-1 text-primary-400" />
                <span>contact@aivision.com</span>
              </li>
              <li className="flex items-start space-x-2">
                <PhoneOutlined className="mt-1 text-primary-400" />
                <span>400-123-4567</span>
              </li>
              <li className="flex items-start space-x-2">
                <EnvironmentOutlined className="mt-1 text-primary-400" />
                <span>北京市朝阳区某某大厦10层</span>
              </li>
            </ul>
          </div>
        </div>

        {/* 底部版权 */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-500">
          <p>© {currentYear} AI Vision Technology. {t('footer.copyright')}.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer

